import { useEffect, useRef, useState } from "react";

/**
 * Shared state/handlers for the "action column" portal dropdown pattern used across
 * table rows (parent rows and nested child rows alike): tracks which row's menu is
 * open, positions it under the clicked button, and closes it on an outside click.
 *
 * `triggerAttr` must match the `data-*` attribute placed on the trigger button so the
 * outside-click handler doesn't close a menu the same click just opened.
 */
export const useRowActionMenu = (triggerAttr = "data-action-trigger") => {
  const [openRowId, setOpenRowId] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handle = (e) => {
      if (e.target.closest(`[${triggerAttr}]`)) return;
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenRowId(null);
      }
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [triggerAttr]);

  const handleActionClick = (id, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
    setOpenRowId((prev) => (prev === id ? null : id));
  };

  return { openRowId, position, dropdownRef, handleActionClick, closeMenu: () => setOpenRowId(null) };
};
